import { cn } from '@/lib/cn';

export interface TabsProps<T extends string> {
  tabs: readonly T[];
  active: T;
  onChange: (tab: T) => void;
  /** Accessible name for the tablist. */
  label: string;
  className?: string;
}

export function Tabs<T extends string>({ tabs, active, onChange, label, className }: TabsProps<T>) {
  return (
    <div
      role="tablist"
      aria-label={label}
      className={cn('flex flex-wrap gap-2 border-b border-border pb-3', className)}
    >
      {tabs.map((tab) => {
        const isActive = tab === active;

        return (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab)}
            className={cn(
              'rounded-pill px-3.5 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.04em] transition',
              isActive
                ? 'bg-primary-muted text-primary'
                : 'text-content-muted hover:bg-white/5 hover:text-content',
            )}
          >
            {tab}
          </button>
        );
      })}
    </div>
  );
}
